import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalSignOutService } from '../../core/modal-sign-out/modal-sign-out.service';

@Component({
  selector: 'app-server-404',
  templateUrl: './server-404.component.html',
  styleUrl: './server-404.component.css'
})
export class Server404Component {

  constructor(
    private router: Router, // Inject the Router service to handle navigation
    private modalSignOutService: ModalSignOutService
  ) { }

  // You can add any additional logic or methods here if needed
  ngOnInit(): void {
    // Initialization logic can go here
  }

  goToLoginPage(): void {
    this.modalSignOutService.openModal();
  }

}
